import React from 'react';
import { Form, Input, App as AntdApp } from 'antd';
import { IconPicker } from './IconPicker';
import { trpc } from '../lib/trpc';
import { withDevModalFilePath, NumericInput, HexColorPicker } from './common';

const { Modal } = withDevModalFilePath('client/src/components/QuickAddCategoryModal.tsx');

interface QuickAddCategoryModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: (categoryId: string, categoryLabel: string) => void;
}

export const QuickAddCategoryModal: React.FC<QuickAddCategoryModalProps> = ({
  open,
  onCancel,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const { message: messageApi } = AntdApp.useApp();
  const utils = trpc.useUtils();

  // カテゴリ作成
  const createMutation = trpc.equipmentCategory.create.useMutation({
    onSuccess: async (data) => {
      messageApi.success('カテゴリを作成しました');
      await utils.equipmentCategory.list.invalidate();
      form.resetFields();
      onSuccess(data.id, data.categoryLabel);
    },
    onError: (error) => {
      messageApi.error(error.message || 'カテゴリの作成に失敗しました');
    },
  });

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      createMutation.mutate({
        categoryLabel: values.categoryLabel,
        description: values.description,
        displayOrder: values.displayOrder || 999,
        color: typeof values.color === 'string' ? values.color : values.color?.toHexString(),
        icon: values.icon,
      });
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="新しいカテゴリを追加"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={createMutation.isPending}
      okText="追加"
      cancelText="キャンセル"
      width={500}
    >
      <Form form={form} layout="vertical" initialValues={{ color: '#1890ff', displayOrder: 999 }}>
        <Form.Item
          label="カテゴリ名"
          name="categoryLabel"
          rules={[
            { required: true, message: 'カテゴリ名を入力してください' },
            { max: 255, message: '255文字以内で入力してください' },
          ]}
        >
          <Input
            placeholder="例: ポンプ"
            autoFocus
          />
        </Form.Item>

        <Form.Item label="説明" name="description">
          <Input.TextArea placeholder="カテゴリの説明（任意）" rows={2} />
        </Form.Item>

        <Form.Item label="カラー" name="color">
          <HexColorPicker />
        </Form.Item>

        <Form.Item label="アイコン" name="icon">
          <IconPicker placeholder="アイコンを選択（任意）" />
        </Form.Item>

        <Form.Item name="displayOrder" hidden>
          <NumericInput />
        </Form.Item>
      </Form>
    </Modal>
  );
};
